export const baseStyles = `
  .mapboxgl-popup {
    min-width: 300px;
    min-height: 200px; 
    padding: '5%'
  }
`;
